import {
  GoogleLogin,
  TokenResponse,
  googleLogout,
  useGoogleLogin,
} from "@react-oauth/google";
import "./create-account.scss";
import { useEffect, useState } from "react";
import axios from "axios";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  registerUserInfo,
  userRegistrationSelector,
} from "../../../redux/reducers/user-registration/userRegistrationSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import { createNewUserSession, userSessionStateSelector } from "../../../redux/reducers/user-session/userSessionSlice";

// Import your assets
import headerImg from "../../../assets/media/icons/Trowel-Logo.png";
import googleLogo from "../../../assets/media/icons/Google logo.png";
import facebookLogo from "../../../assets/media/icons/facebook logo.png";
import instagramLogo from "../../../assets/media/icons/instagram logo.png";
import { error } from "console";

const CreateAccount: React.FC = () => {
  let apiUrl = process.env.REACT_APP_API_URL || "https://trowelwa01.azurewebsites.net/api/";
  // Ensure apiUrl ends with a slash
  if (!apiUrl.endsWith('/')) {
    apiUrl += '/';
  }

  const [userName, setUserName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [user, setUser] = useState<UserType | null>(null);
  const [profile, setProfile] = useState<any>([]);

  const navigate = useNavigate();
  const selectUserInfo = useAppSelector(userRegistrationSelector);
  const selectUserSessionInfo = useAppSelector(userSessionStateSelector);
  const dispatch = useAppDispatch();

  type userProfile = {
    email: string;
    id: string;
    given_name: string;
    name: string;
    picture: string;
    verified_email: boolean;
  };

  type UserType = Omit<
    TokenResponse,
    "error" | "error_description" | "error_uri"
  >;

  // Google login logic
  const registerToTrowelUsingGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
      sessionStorage.setItem("access_token", codeResponse.access_token);
      dispatch(
        createNewUserSession({
          ...selectUserSessionInfo,
          accessToken: codeResponse.access_token,
          name: userName,
          email: userName,
        })
      );
    },
    onError: (error) => console.log("loging failed : ", error),
  });

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          setProfile(res.data);
          let signupRequestUrl: string = `${apiUrl}auth/o2/signup`;
          let userProfile: userProfile = res.data;
          if (userProfile?.verified_email) {
            axios
              .post(signupRequestUrl, {
                username: userProfile.name,
                email: userProfile.email,
                token: user.access_token,
              })
              .then((response) => {
                let { message, userId, status } = response.data;
                if (status.toLowerCase() !== "success") {
                  toast.error("Registration failed, " + message);
                  return;
                }
                toast.success(message);
                dispatch(
                  registerUserInfo({
                    ...selectUserInfo,
                    name: userProfile.name,
                    email: userProfile.email,
                    id: userId,
                    profileImage: userProfile.picture,
                  })
                );
                navigate("/registration-confirmation");
              })
              .catch((err: any) => {
                let { detail } = err.response.data;
                toast.error("Registration failed, " + detail);
              });
          }
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  const logOut = () => {
    googleLogout();
    setProfile(null);
  };

  const createNewTrowelAccount = () => {

    // Check email, your nam and password are not empty and which one is missing show the specific error message
    // If all are present then proceed
    const missingFields: string[] = [];
    if (!email) missingFields.push("Email");
    if (!userName) missingFields.push("Name");
    if (!password) missingFields.push("Password");

    if (missingFields.length > 0) {
      toast.error(`${missingFields.join(", ")} ${missingFields.length === 1 ? "is" : "are"} required`);
      return;
    }

    let signupRequestUrl: string = `${apiUrl}auth/signup`;
    axios
      .post(signupRequestUrl, { username: userName, email: email, password: password })
      .then((response: any) => {
        let { userId } = response.data;
        dispatch(
          registerUserInfo({
            ...selectUserInfo,
            name: userName,
            email: email,
            id: userId,
            profileImage: undefined,
          })
        );
        navigate("/registration-confirmation");
      })
      .catch((err: any) => {
        toast.error("User registration failed, please try again later.");
      });
  };

  return (
    <div className="register-bg">
      <div className="container-fluid">
        <div className="row">
          <div className="col app-header" >
            <img className="logo-img" src={headerImg} alt="Header" onClick={()=>navigate('/')}/>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6 justify-content-center">
            <div className="w-100 justify-content-center auth-card register">
              <div className="justify-content-center row">
                <div className="col-md-10 col-sm-12 col-lg-8">
                  <h3 className="text-center">Create an Account</h3>
                  <p className="text-center text-muted mb-4">Join Our Community</p>
                  <button className="btn w-100 btn-social" onClick={() => registerToTrowelUsingGoogle()}>
                    <img className="img-fluid" width={24} height={25} src={googleLogo} alt="Google" />
                    Google
                  </button>
                  <button className="btn w-100 btn-social">
                    <img className="img-fluid" width={25} height={25} src={facebookLogo} alt="Facebook" />
                    Facebook
                  </button>
                  <button className="btn w-100 btn-social">
                    <img className="img-fluid" width={25} height={25} src={instagramLogo} alt="Instagram" />
                    Instagram
                  </button>
                  <div className="text-center my-3">
                    <span className="text-reset" style={{ color: "#656565" }}>OR</span>
                  </div>
                  <div>
                    <input
                      className="mb-3 form-control register-input"
                      type="email"
                      placeholder="Work Email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                    />
                    <input
                      className="mb-3 form-control register-input"
                      type="text"
                      placeholder="Your Name"
                      value={userName}
                      onChange={e => setUserName(e.target.value)}
                    />
                    <input
                      className="mb-3 form-control register-input"
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                    />
                    <button className="btn btn-lg w-100 btn-main" type="button" onClick={createNewTrowelAccount}>
                      Get started for free
                    </button>
                  </div>
                  <div className="text-center mt-3">
                    <small>
                      Already have an account?{" "}
                      <span
                        className="fw-bold text-decoration-none login-link"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/login")}
                      >
                        Login
                      </span>
                    </small>
                  </div>
                  <div className="text-center mt-3">
                    <small className="text-muted">
                      By continuing, you agree to App’s{" "}
                      <span className="text-decoration-none text-info other-link" style={{ cursor: "pointer" }}>
                        User Agreement
                      </span>{" "}
                      &amp;{" "}
                      <span className="text-decoration-none text-info other-link" style={{ cursor: "pointer" }}>
                        Privacy Policy
                      </span>.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="circle-bg circle1"></div>
    </div>
  );
};

export default CreateAccount;
